import { FC } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
} from 'recharts';
import dayjs from 'dayjs';
import { ISrpeWeeklyMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ISrpeWeeklyMetric | null;
  period?: string;
  height?: number;
}

export const SrpeWeeklyChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.weeks || data.weeks.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <BarChart data={data.weeks} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="week" tickFormatter={(v) => dayjs(v).format('DD/MM')} tick={chartAxisTick} />
        <YAxis tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(_value, _name, props) => {
            const { week, totalSrpe, sessions } = props.payload;
            return [`sRPE: ${Math.round(totalSrpe)} · Sessioni: ${sessions}`, dayjs(week).format('DD/MM/YYYY')];
          }}
        />
        <Bar dataKey="totalSrpe" fill="var(--c-text-0)" radius={[4, 4, 0, 0]} />
        {data.injuryMarkers?.map((marker) => (
          <ReferenceLine
            key={marker.injuryId}
            x={marker.date}
            stroke="var(--ri-critical)"
            strokeWidth={1.5}
            label={{
              value: marker.bodyZone,
              position: 'top',
              fontSize: 10,
              fill: 'var(--ri-critical)',
              fontFamily: "'Satoshi', sans-serif",
            }}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
